import { handleTrack } from '../../../utils/tracker';
import { TopCTABannerITR } from '../styles';

const TopCTABanner = ({ bannerLink: _bannerLink }: { bannerLink?: string }) => {
  return (
    <>
      <TopCTABannerITR>
        <div className="banner_outer_outer_container">
          <a
            href={` ${
              _bannerLink ||
              'https://cleartax.in/filing?utm_ref=itr_2025_organic_topcta_deadline'
            }`}
            target="_blank"
            className="anchor-tag"
            rel="noreferrer"
            onClick={() =>
              handleTrack({ label: 'itr_2025_organic_topcta_deadline' })
            }
          >
            <div className="banner_outer_container">
              <div className="left-section">
                <picture>
                  <source
                    media="(min-width: 1440px)"
                    srcSet="
                  https://assets.clear.in/cleartax/images/1758537492_maskgroup1.webp
                "
                  />
                  <source
                    media="(min-width: 1024px)"
                    srcSet="
                  https://assets.clear.in/cleartax/images/1758537496_maskgroup2.webp
                "
                  />
                  <source
                    media="(min-width: 768px)"
                    srcSet="
                  https://assets.clear.in/cleartax/images/1758537498_maskgroup3.webp
                "
                  />
                  <img
                    className="banner-image"
                    src="https://assets.clear.in/cleartax/images/1758537501_maskgroup4.webp"
                    alt="itr-deadline-15th-september-banner"
                    width="182"
                    height="200"
                    loading="eager"
                  />
                </picture>
              </div>
              <div className="mid-section">
                <picture>
                  <img
                    className="small-banner-image"
                    src="https://assets.clear.in/cleartax/images/1758537501_maskgroup4.webp"
                    alt="itr-deadline-15th-september-banner"
                    width="182"
                    height="200"
                    loading="eager"
                  />
                </picture>
                <div className="heading">Missed the deadline?</div>
                <div className="small-heading">
                  Missed the <br />
                  deadline?
                </div>
                <div className="subheading">File ITR with 100% Accuracy</div>
              </div>
              <div className="banner-right">
                <div className="right-subsection-small">
                  <div className="banner-button">File Now</div>
                </div>
                <div className="right-subsection">
                  <div className="banner-button">File Now</div>
                </div>
              </div>
            </div>
          </a>
        </div>
      </TopCTABannerITR>
    </>
  );
};

export default TopCTABanner;
